// Imports
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(true);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".slick-next {\n  right: 20px !important;\n}\n.slick-prev {\n  left: 20px !important;\n  z-index: 999;\n}\n", "",{"version":3,"sources":["webpack://src/assets/style/slider.css"],"names":[],"mappings":"AAAA;EACE,sBAAsB;AACxB;AACA;EACE,qBAAqB;EACrB,YAAY;AACd","sourcesContent":[".slick-next {\n  right: 20px !important;\n}\n.slick-prev {\n  left: 20px !important;\n  z-index: 999;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
